import cx from 'classnames';
import { PropsWithChildren } from 'react';

import s from './Overlay.css';

type Props = { className?: string; status: string };

export const Overlay = ({ className, children, status }: PropsWithChildren<Props>): JSX.Element => (
    <div
        className={cx(s.overlay, className, {
            [s.visible]: status === 'entering',
            [s.visible]: status === 'entered',
            [s.transparent]: status === 'exiting',
            [s.transparent]: status === 'exited',
        })}
    >
        {children}
    </div>
);
